import React from 'react';
import Icon from '../../../components/AppIcon';

const TrendingSection = ({ articles, onArticleClick }) => {
  return (
    <section className="mb-12">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-to-r from-orange-500 to-red-500 rounded-xl flex items-center justify-center">
            <Icon name="TrendingUp" size={20} className="text-white" />
          </div>
          <div>
            <h2 className="font-heading font-bold text-2xl text-accent-800">Trending Now</h2>
            <p className="text-accent-600">Most popular gift guides this week</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {articles?.map((article, index) => (
          <div
            key={article?.id}
            onClick={() => onArticleClick?.(article)}
            className="bg-white rounded-2xl shadow-soft border border-accent-100 overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer group relative"
          >
            {/* Trending Badge */}
            <div className="absolute top-4 left-4 bg-gradient-to-r from-orange-500 to-red-500 text-white px-3 py-1 rounded-full text-xs font-medium z-10">
              <Icon name="Flame" size={12} className="inline mr-1" />
              #{index + 1} Trending
            </div>

            {/* Article Image */}
            <div className="relative overflow-hidden">
              <img
                src={article?.image}
                alt={article?.title}
                className="w-full h-40 object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
            </div>

            {/* Article Content */}
            <div className="p-6">
              <h3 className="font-heading font-semibold text-lg text-accent-800 mb-2 group-hover:text-primary transition-colors line-clamp-2">
                {article?.title}
              </h3>

              <p className="text-accent-600 text-sm mb-4 line-clamp-2">
                {article?.excerpt}
              </p>

              {/* Stats */}
              <div className="flex items-center justify-between text-xs text-accent-500">
                <div className="flex items-center space-x-4">
                  <div className="flex items-center space-x-1">
                    <Icon name="Eye" size={12} />
                    <span>{(article?.views / 1000).toFixed(1)}K</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <Icon name="Share" size={12} />
                    <span>{article?.shares}</span>
                  </div>
                </div>
                <div className="flex items-center space-x-1">
                  <Icon name="Clock" size={12} />
                  <span>{article?.readTime} min</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrendingSection;